<template>
  <span>
    <v-skeleton-loader v-if="preparing" type="chip" class="check-positions-loader"></v-skeleton-loader>
    <span v-else class="v-chip theme--dark v-size--small check-positions-block">
      <span
        v-for="position in positions"
        :key="position.datacenter"
        style="flex: 1 1 auto;"
        :class="'check-positions-item ' + getColor(position.value)"
        @click="clicked(check, position.datacenter)"
      >
        <span v-if="position.value === 0">X</span>
        <span v-else>{{ position.value }}</span>
      </span>
      <span v-if="loading" :style="'flex: 1 1 auto;'" class="check-positions-loader grey lighten-2">
        <v-icon small color="white">mdi-loading mdi-spin mdi-anim-1s</v-icon>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'CheckPositions',
  props: ['check', 'datacenters'],
  computed: {
    preparing () {
      return !this.datacenters || Object.values(this.datacenters).length === 0
    },
    loading () {
      return this.preparing || Object.values(this.datacenters).filter(position => position === null).length > 0
    },
    positions () {
      const result = []

      for (const [datacenter, position] of Object.entries(this.datacenters)) {
        if (position !== null && position !== false) {
          result.push({ datacenter, value: position })
        }
      }

      return result
    },
  },
  methods: {
    getColor (value) {
      value = parseInt(value)
      if (value === 0) return 'error'
      if (value === 1) return 'success'
      if (value === 2) return 'light-green'
      if (value === 3) return 'lime'
      if (value < 10) return 'orange'
      else return 'error'
    },
    getPercentage (count) {
      return Math.round(count / Object.keys(this.filledDatacenters).length * 100)
    },
    clicked (check, datacenter) {
      this.$emit('clicked', { check, datacenter })
    }
  }
}
</script>

<style>
.v-chip.check-positions-block {
  display: flex;
  padding: 0;
  background: white !important;
}

.v-chip.check-positions-block .check-positions-item {
  text-align: center;
  transition: all 0.25s;
  cursor: pointer;
  line-height: 24px;
}

.v-chip.check-positions-block .check-positions-item:last-child {
  border-right: 0 !important;
}

.v-chip.check-positions-block .check-positions-loader {
  transition: all 0.5s;
  text-align: center;
  padding: 0;
  line-height: 24px;
  padding-right: 3px;
  flex: 1 1 auto;
}

.v-chip.check-positions-block .check-positions-item:hover {
  background-color: white !important;
  color: black;
}

.check-positions-loader > div {
  height: 24px;
  width: 100%;
}
</style>